module.exports = __webpack_public_path__ + "static/logo-rd-smart-tax.7cb888d3.jpg";